import { all, takeEvery, call, put, select } from 'redux-saga/effects';
import actions from './actions';
import { getDevices } from '../../../api/devices/devices.api';
import { SERVER_ERRORS } from '../../../api/SERVER_ERRORS';
import notifications from '../notification/actions';
import {getDeviceType} from "../deviceVersion/selectors";

function* fetchDevices(payload) {
    try {
        const isKarieDUO = yield select(getDeviceType);
        const params = {
            ...payload.search,
            isKarieDUO
        }
        const response = yield call(getDevices, params ? params : {});
        if (response.devices) {
            yield put(actions.fetchDevicesSuccess(response.devices));
        } else {
            yield put(notifications.createNotification({
                ...response[0],
                mainAction: actions.FETCH_DEVICES_ERROR,
            }));
        }
    } catch (error) {
        yield put(notifications.createNotification({
            mainAction: actions.FETCH_DEVICES_ERROR,
            code: SERVER_ERRORS.UNKNOWN_SERVER_ERROR
        }));
    }
}

export default function* rootSaga() {
    yield all([
        takeEvery(actions.FETCH_DEVICES, fetchDevices),
    ]);
}
